import { useState } from 'react'
import Graphs from '../../Graphs'
import { useSection } from '../../../context/section'
import AccordionConatiner from '../../ui/accordion/AccordionConatiner'
import { DeleteOutlineOutlined, ContentCopy, ExitToApp } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import ExportModal from './ExportModal'

const ResearchSection = ({projectId}) => {
    const [exportModal, setExportModal] = useState(false)

    const { ticker, isExpand,  sectionId, analyze, tab, setTab, dataset, financialInfo, dragHandleProps, changeIsExpand, handleDuplicateSection, handleRemoveSection, sectionName, updateSectionName, selectedData } = useSection()
    const panelTabsProps = { ticker, financialInfo, analyze, sectionId, tab, setTab, dataset}
    const handleCloseExportModal = () => setExportModal(false)

    const handleClickExport = () => {
        setExportModal(true)
    }

    const menuItems = [
        <MenuItem onClick={handleDuplicateSection}><ContentCopy/> Duplicate</MenuItem>,
        <MenuItem onClick={handleClickExport}><ExitToApp/> Export to CSV</MenuItem>,
        <MenuItem onClick={handleRemoveSection}><DeleteOutlineOutlined/> Remove</MenuItem>
    ]

    return (
        <>
            <AccordionConatiner isExpand={isExpand} dragHandleProps={dragHandleProps} menuItems={menuItems} changeIsExpand={changeIsExpand} text={sectionName} onSetText={updateSectionName}>
                <Graphs { ...panelTabsProps } projectId={projectId} />
            </AccordionConatiner>
            <ExportModal open={exportModal} close={handleCloseExportModal} dataset={dataset} ticker={ticker} financialInfo={selectedData.financialInfo}/>
        </>
    )
}

export default ResearchSection